import { useAppDispatch } from '../store/index'
import { uiActions } from '../store/index'
import { authService } from '../services/authService'
import { useNavigate } from 'react-router-dom'

export function MobileOnlyPage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await authService.logout()
    dispatch(uiActions.logout())
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center space-y-6">
        <div className="text-6xl">📱</div>
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">Use the Mobile App</h1>
          <p className="text-gray-400 text-sm leading-relaxed">
            Team admin features — runner roster, leg assignments, race-day controls, and GPS tracking — are available in the Relay Tracker mobile app.
          </p>
        </div>
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-5 text-left space-y-3">
          <p className="text-gray-300 text-sm font-semibold">Download the app:</p>
          <div className="space-y-2 text-sm text-gray-400">
            <p>• Search <span className="text-white font-medium">Relay Tracker</span> on the App Store or Google Play</p>
            <p>• Log in with the same username and password</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="w-full py-3 rounded-xl bg-gray-700 text-gray-300 font-semibold hover:bg-gray-600 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  )
}
